module.exports = __webpack_public_path__ + "img/PinkOutline640.8e6b6b35.png";